import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'
import { DemonstrativoMetaFamiliaMesTotal } from '@/modules/home/types/demonstrativo-meta-familia-mes-total'

export interface Payload {
  vendedor?: string
  dataInicio: string
  dataFim: string
}

export const demonstrativoMetaFamilaTotalMesServiceByDates = async (
  payload: Payload,
): Promise<ResponseAPI> => {
  const response = await api.get(
    `demonstrativometafamiliatotalperiodo/${payload.dataInicio}/${payload.dataFim}`,
    { headers: payload.vendedor ? { vendedor: payload.vendedor } : undefined },
  )

  return response.data
}
